import Vue from 'vue';
import CONSTANTS from './constants';
// import { StateType } from './types';

export default {
  [CONSTANTS.SET_ORDERLIST_PARAMS](_state: any, orderListParams: object): void {
    Vue.set(_state, 'orderListParams', orderListParams);
  },
  [CONSTANTS.SET_SINGLE_ORDER_PARAMS](_state: any, orderParams: object): void {
    Vue.set(_state, 'singleOrderParams', orderParams);
  },
  [CONSTANTS.SET_HIDING_ORDER_MODULES](_state: any, hidingOrderModulesWhenNoImps: object): void {
    Vue.set(_state, 'hidingOrderModulesWhenNoImps', hidingOrderModulesWhenNoImps);
  },

  [CONSTANTS.SET_IS_ORDER_METRICS_CACHED](_state: any, isOrderMetricsCached: boolean): void {
    Vue.set(_state, 'isOrderMetricsCached', isOrderMetricsCached);
  },
  [CONSTANTS.SET_ORDER_DATA](_state: any, { method, data }: { method: string; data: object }): void {
    Vue.set(_state.orderData, `${method}Data`, data);
  },
  [CONSTANTS.SET_ORDER_DATA_CACHE_URL](
    _state: any,
    { method, orderDataCacheUrl }: { method: string; orderDataCacheUrl: string },
  ): void {
    Vue.set(_state.orderData, `${method}CacheUrl`, orderDataCacheUrl);
  },
  [CONSTANTS.SET_IS_ORDER_DATA_LOADING](
    _state: any,
    { method, isLoading }: { method: string; isLoading: boolean },
  ): void {
    Vue.set(_state.orderData, `${method}IsLoading`, isLoading);
  },
  [CONSTANTS.RESET_ORDER_DATA](_state: any): void {
    Vue.set(_state, 'orderData', {});
  },
};
